<template>
  <v-list nav class="px-0">
    <v-list-item-group v-model="locale" active-class="info white--text">
      <v-list-item
        v-for="locale in locales"
        :key="locale.code"
        @click="setLocale(locale)"
        :value="locale.code"
        class="accent px-4"
        height="40px"
      >
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-regular">{{
            locale.name.toUpperCase()
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { getSupportedLocales } from "@/helpers/i18n/supported-locales";

export default {
  name: "LocaleSwitcher",
  data: () => ({
    locales: getSupportedLocales(),
    locale: "",
  }),
  methods: {
    setLocale(locale) {
      if (locale.code) {
        import(
          /* webpackChunkName: "locales-[request]" */ `@/locales/${locale.code}.json`
        ).then((msgs) => {
          this.$root.$i18n.setLocaleMessage(locale.code, msgs.default);
          this.$root.$i18n.locale = locale.code;
          this.$ls.set("locale", locale.code);
          locale.active = true;
        });
      }
    },
  },
  mounted() {
    this.locale = this.$i18n.locale;
  },
};
</script>

<style lang="scss"></style>
